
export const menuItems = [
  {
    id: 'switcholdui',
    label: 'Switch to OldUI',
    description: 'Switch to previous version',
    path: '/?activateoldui=true',
    disabled: false,
    hidden: false,
    menuType: 'link',
    icon: 'bi-arrow-left-right',
  },
  {
    id: 'dashboard',
    label: 'Summary',
    description: 'Quick overview of business metrics',
    path: '/dashboard',
    disabled: false,
    hidden: false,
    menuType: 'link',
    icon: 'bi-clipboard-data-fill',
  },
  {
    id: 'jobdashboard',
    label: 'Job Dashboard',
    description: 'Monitor all job activities',
    path: '/servicenear/dashboard',
    disabled: false,
    hidden: false,
    menuType: 'link',
    icon: 'bi-list-check',
  },
  {
    id: 'addservice',
    label: 'Add Service',
    description: 'Add a new service',
    path: '/servicenear/serviceAdd',
    disabled: false,
    hidden: false,
    menuType: 'link',
    icon: 'bi-plus-circle-fill',
  },
  {
    id: 'services',
    label: 'Services',
    description: 'Manage service-related operations',
    disabled: false,
    hidden: false,
    menuType: 'expandable',
    expanded: false,
    icon: 'bi-wrench-adjustable',
    children: [
      {
        id: 'servicelist',
        label: 'Service List',
        description: 'View & manage all services',
        path: '/servicenear/serviceList',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },
      {
        id: 'shopreport',
        label: 'Shop Report',
        description: 'View reports for shops',
        path: '/servicenear/shopreport',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },
      {
        id: 'serviceproductlist',
        label: 'Service Product List',
        description: 'View all service products',
        path: '/servicenear/serviceProductList',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },
      {
        id: 'createserviceproduct',
        label: 'Create Service Product',
        description: 'Create new service product',
        path: '/admin/',
        disabled: true,
        hidden: false,
        menuType: 'link',
        icon: 'bi-plus-circle-fill',
      },
      {
        id: 'servicepos',
        label: 'Service POS',
        description: 'Process service orders via POS',
        path: '/admin/',
        disabled: true,
        hidden: true,
        menuType: 'link',
        icon: 'bi-arrow-right-circle-fill',
      },
    ]
  },
  {
    id: 'sales',
    label: 'Sales',
    description: 'Manage sales-related operations',
    disabled: false,
    hidden: false,
    menuType: 'expandable',
    expanded: false,
    icon: 'bi-cash-stack',
    children: [
      {
        id: 'pos',
        label: 'POS',
        description: 'Create sales using POS',
        path: '/admin/add',
        disabled: true,
        hidden: false,
        menuType: 'link',
        icon: 'bi-arrow-right-circle-fill',
      },
      {
        id: 'saleslist',
        label: 'Sales List',
        description: 'View & manage all sales',
        path: '/servicenear/saleslist',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },
      {
        id: 'return',
        label: 'Return',
        description: 'Initiate Return',
        path: '/admin/list',
        disabled: true,
        hidden: false,
        menuType: 'link',
        icon: 'bi-arrow-left-circle-fill',
      },
      {
        id: 'returnlist',
        label: 'Return List',
        description: 'View & track all returns',
        path: '/admin/list',
        disabled: true,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },

    ]
  },
  {
    id: 'secondhand',
    label: 'Secondhand',
    description: 'Manage secondhand sales',
    disabled: false,
    hidden: false,
    menuType: 'expandable',
    expanded: false,
    icon: 'bi-briefcase',
    children: [
      {
        id: 'createsecondhandpurchase',
        label: 'Create Secondhand Purchase',
        description: 'Create secondhand purchase entry',
        path: '/secondhand/purchaseAdd',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-plus-circle-fill',
      },
      {
        id: 'secondhandlist',
        label: 'Secondhand List',
        description: 'View & manage secondhand purchases',
        path: '/secondhand/purchaseList',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },
    ]
  },
  {
    id: 'payin',
    label: 'Pay In',
    description: 'Manage cash collections',
    path: '/servicenear/payin',
    disabled: false,
    hidden: false,
    menuType: 'link',
    expanded: false,
    icon: 'bi-credit-card-fill',
    children: []
  },
  {
    id: 'shopscustomers',
    label: 'Shops/Customers',
    description: 'View all shops/customers',
    disabled: false,
    hidden: false,
    menuType: 'expandable',
    expanded: false,
    icon: 'bi-people-fill',
    children: [
      {
        id: 'addshop',
        label: 'Add Shop',
        description: 'Add a new shop',
        path: '/user/customer-add/shop',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-building-fill-add',
      },
      {
        id: 'shoplist',
        label: 'Shop List',
        description: 'View & manage all shops',
        path: '/user/shoplist',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },
      {
        id: 'addcustomer',
        label: 'Add Customer',
        description: 'Add a new customer',
        path: '/user/customer-add/user',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-person-fill-add',
      },
      {
        id: 'customerlist',
        label: 'Customer List',
        description: 'View & manage all customers',
        path: '/user/userlist',
        disabled: false,
        hidden: false,
        menuType: 'link',
        icon: 'bi-list-check',
      },
    ]
  },
  {
    id: 'more',
    label: 'More',
    description: 'View additional settings & features',
    path: '/servicenear/moreMenuList',
    disabled: false,
    hidden: false,
    menuType: 'link',
    expanded: false,
    icon: 'bi-three-dots-vertical',
    children: []
  },
]

export interface MoreMenuItem {
  id: string;
  label: string;
  disabled: boolean;
  hidden: boolean;
  path: string;
  icon?: string;
  showDeleteBtn?: boolean;
}

export interface MoreMenuSection {
  id: string,
  header: string;
  expanded: boolean;
  disabled: boolean;
  hidden: boolean;
  items: MoreMenuItem[];
}

export const moreMenuItems: MoreMenuSection[] = [
  {
    id: 'user',
    header: 'User Management',
    expanded: false,
    disabled: false,
    hidden: false,
    items: [
      {
        id: 'userlist',
        label: 'User List',
        disabled: false,
        hidden: false,
        path: '/user/list'
      },
      {
        id: 'adduser',
        label: 'Add User',
        disabled: false,
        hidden: false,
        path: '/user/add'
      }
    ]
  },

  {
    id: 'products',
    header: 'Products Management',
    expanded: false,
    disabled: false,
    hidden: false,
    items: [
      {
        id: 'prodlist',
        label: 'Product List',
        disabled: false,
        hidden: false,
        path: '/products/product-list'
      },
      {
        id: 'createprod',
        label: 'Create Product',
        disabled: false,
        hidden: false,
        path: '/products/product-edit/0'
      },
      {
        id: 'categorylist',
        label: 'Category List',
        disabled: false,
        hidden: false,
        path: '/products/categories'
      },
      {
        id: 'damage',
        label: 'Damage List',
        disabled: false,
        hidden: false,
        path: '/products/Damagelist'
      },
      {
        id: 'excel',
        label: 'Excel Upload',
        disabled: true,
        hidden: false,
        path: ''
      }
    ]
  },
  {
    id: 'info',
    header: 'Info',
    expanded: false,
    disabled: false,
    hidden: false,
    items: [
      {
        id: 'plans',
        label: 'Plans',
        disabled: true,
        hidden: false,
        path: ''
      },
      {
        id: 'whatsnew',
        label: "What's New?",
        disabled: false,
        hidden: false,
        path: '/servicenear/whatsnew'
      },
      {
        id: 'faq',
        label: 'FAQ',
        disabled: true,
        hidden: false,
        path: ''
      },
    ]
  },
  {
    id: 'account',
    header: 'My Account',
    expanded: false,
    disabled: false,
    hidden: false,
    items: [
      {
        id: 'profile',
        label: 'Profile',
        disabled: false,
        hidden: false,
        path: '/servicenear/profile'
      },
      {
        id: 'accinfo',
        label: 'Account Info',
        disabled: false,
        hidden: false,
        path: '/servicenear/accountInfo'
      },
      {
        id: 'servicenearsettings',
        label: 'Settings',
        disabled: false,
        hidden: true,
        path: '/servicenear/settings'
      },
      {
        id: 'mybills',
        label: 'My Subscriptions',
        disabled: false,
        hidden: false,
        path: '/profile/SubscriptionDetails'
      },
      {
        id: 'sentmsg',
        label: 'Sent Message',
        disabled: true,
        hidden: false,
        path: ''
      },
      {
        id: 'changepass',
        label: 'Change Password',
        disabled: false,
        hidden: false,
        path: '/servicenear/changePassword'
      },
      {
        id: 'logout',
        label: 'Logout',
        disabled: false,
        hidden: false,
        path: 'logout'
      },
    ]
  }
];
